import dashboard from "./dashboard.png";
import thesis from "./thesis.png";

export default [
  {
    projectTitle: "Dashboard App",
    imageSource: dashboard,
    description:
      "This dashboard app, built in React, includes a collection of useful features to keep the users day organised. The main features are a to-do list, a quick weather preivew, an outline of an upcoming training plan and Strava integration to show the current week's progress.",
    link: "zaclew.com",
  },
  {
    projectTitle: "Digital Triage Tool",
    imageSource: thesis,
    description:
      "This Digital Triage Tool, built in React and in conjuction with the Sydney Children's Hosptial, allows clinicians to easily survey patients before they attend their sessions at the hospital.",
    link: "zaclew.com",
  },
];
